import React, { useState } from 'react';

import { ReactComponent as ExpanderIcon } from 'theme/assets/images/up-arrow.svg';
import './Accordion.scss';

export interface IAccordionProps {
  title: string;
  showCount: boolean;
  children: React.ReactElement[];
}

const Accordion: React.FC<IAccordionProps> = (props: IAccordionProps) => {
  const [expanded, setExpanded] = useState<boolean>(true);

  let expanderStyle: 'up' | 'down';
  let bodyStyle: 'visible' | 'hidden';
  if (expanded) {
    expanderStyle = 'up';
    bodyStyle = 'visible';
  } else {
    expanderStyle = 'down';
    bodyStyle = 'hidden';
  }

  return (
    <div className="accordion">
      <div className="accordion__header">
        <div className="accordion__title">
          <span>{props.title}</span>
          {props.showCount && <span> ({props.children.length})</span>}
        </div>
        <ExpanderIcon className={`accordion__expander accordion__expander--${expanderStyle}`} onClick={() => setExpanded(!expanded)} />
      </div>
      <div className={`accordion__body accordion__body--${bodyStyle}`}>{props.children}</div>
    </div>
  );
};

export default Accordion;
